import { useNavigate } from "react-router-dom";
import { MedicalAssistanceDependantSelection } from ".";
import { MembershipDependentIdentityDocumentType } from "@/services/core-api-adapter";

export default function MedicalAssistanceDependantSelectionExamples() {
  const navigate = useNavigate();

  function onNextButtonClick() {
    navigate("/home/get-medical-assistance");
  }
  return (
    <MedicalAssistanceDependantSelection
      onNextButtonClick={onNextButtonClick}
      dependants={[
        {
          memberId: "",
          firstName: "Nuki",
          lastName: "Persona",
          identityDocumentType:
            MembershipDependentIdentityDocumentType.ID_NUMBER,
          identityDocumentValue: "0001010001087",
          sexAtBirth: "female",
          dateOfBirth: "1996-03-12",
          identityDocumentCountryOfIssue: "ZAF",
        },
        {
          memberId: "",
          firstName: "Nuki",
          lastName: "Test",
          identityDocumentType: null,
          identityDocumentValue: null,
          sexAtBirth: "female",
          dateOfBirth: "1996-03-12",
          identityDocumentCountryOfIssue: "ZAF",
        },
      ]}
    />
  );
}
